module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-full"
  }, [_c('change-status', {
    ref: "changeStatus"
  }), _vm._v(" "), _c('div', {
    staticClass: "pregao",
    class: {
      'show-keyboard': _vm.centerContentFolded, 'isLoading': _vm.isLoading
    }
  }, [_c('p-menu'), _vm._v(" "), _c('pregao-menu-stats', {
    attrs: {
      "pregao": _vm.pregao,
      "leilao": _vm.leilao,
      "stats": _vm.stats
    },
    on: {
      "abrirPregao": _vm.abrirPregao
    }
  }), _vm._v(" "), _c('lote-leilao-stats', {
    ref: "painelLote",
    attrs: {
      "lote": _vm.lote,
      "leilao": _vm.leilao
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-center"
  }, [_c('lote-info', {
    attrs: {
      "lote": _vm.lote
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "manager-lances"
  }, [_c('historico-lances', {
    attrs: {
      "lote": _vm.lote
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lance-actions"
  }, [_c('i-lance-manual', {
    on: {
      "lanceManual": _vm.lanceManual
    }
  }), _vm._v(" "), _c('i-alterar-incremento', {
    on: {
      "alterarIncremento": _vm.alterarIncremento
    }
  }), _vm._v(" "), _c('chat-comitente-resumido')], 1)], 1)], 1), _vm._v(" "), _c('u-keyboard', {
    ref: "keyboard",
    attrs: {
      "startShow": _vm.centerContentFolded
    },
    on: {
      "mudarLote": _vm.mudarLote,
      "statusLote": _vm.statusLote,
      "deletarLance": _vm.deletarLance,
      "novoLance": _vm.novoLance,
      "toggle": _vm.toggleKeyboard
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4edd0541","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/pregao-comitente/Main.vue
// module id = 1675
// module chunks = 17